<template>
  <div class="companyGood-container">
    <!-- 标题 -->
    <div class="allTitle selfTitle">
      公司优势
    </div>
    <!-- 公司优势内容 -->
    <div class="listBox">
      <div v-for="(item,index) in list" :key="index" class="boxItem">
        <div class="itemIcon">
          <svg class="icon" aria-hidden="true">
            <use :xlink:href="item.imgUrl"></use>
          </svg>
        </div>
        <div class="itemTitle">
          {{item.title}}
        </div>
        <div class="itemLine"></div>
        <div class="itemContent">
          {{item.content}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'companyGood',
  data(){
    return {
      list:[
        {
          imgUrl:'#icon-rengongzhineng',
          title:'人工智能',
          content:'深耕视觉理解与人工智能技术，拥有人脸、人体、行为、物体、语音语义等多类自研算法。'
        },
        {
          imgUrl:'#icon-xunixianshi',
          title:'虚拟现实',
          content:'公司通过对虚拟现实技术的深入研究与业务积累，形成了包含VR、MR等XR（扩展现实）的技术应用。'
        },
        {
          imgUrl:'#icon-funengchanye',
          title:'赋能公安',
          content:'公司将视觉理解与虚拟现实技术深度应用在公安行业，并且仍在不断探索新的方向。'
        },
        {
          imgUrl:'#icon-rencaijuji',
          title:'人才聚集',
          content:'来自人工智能、虚拟现实相关领域的管理和技术人才；政府、公安相关职能部门教训领域的多名专家顾问。'
        },
        {
          imgUrl:'#icon-shengenghangye',
          title:'深耕行业',
          content:'在上海公安行业人工智能产品销售破亿。以丰富的行业经验、深刻的行业理解和产品化能力助力客户解决核心需求问题。'
        },
        {
          imgUrl:'#icon-jinjunshixun',
          title:'警务实训',
          content:'公司基于人工智能和虚拟现实领域的技术积累，在两大技术的加持下，为公安行业打造数字化警务实训平台。'
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.companyGood-container{
  .selfTitle{
    margin-bottom:50px;
  }
  .listBox{
    margin-top:38px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .boxItem{
      display: flex;
      flex-flow:column nowrap;
      padding:20px;
      align-items: center;
      width:28%;
      margin-bottom:80px;
      .itemIcon{
        width:65px;
        height:65px;
      }
      .itemTitle{
        margin-top:10px;
        font-size:20px;
      }
      .itemLine{
        margin-top:10px;
        background-color:#C5C5C5;
        width:180px;
        height:1px;
      }
      .itemContent{
        margin-top:10px;
      }
    }
    .boxItem:hover{
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    }
  }
}

@media screen and (max-width:767px) {
  .companyGood-container{
    .selfTitle{
      margin-bottom:20px;
    }
    .listBox{
      // margin-top:38px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      .boxItem{
        display: flex;
        flex-flow:column nowrap;
        
        align-items: center;
        width:100%;
        margin-bottom:30px;
        .itemIcon{
          width:65px;
          height:65px;
        }
        .itemTitle{
          margin-top:10px;
          font-size:20px;
        }
        .itemLine{
          margin-top:10px;
          background-color:#C5C5C5;
          width:180px;
          height:1px;
        }
        .itemContent{
          margin-top:10px;
        }
      }
    }
  }
}
</style>